import { NotificationsService } from 'angular2-notifications';
import { Contract } from './../interfaces/contract.model';
import { PaymentsService } from './../services/payments.service';
import { LocalStorageService } from './../services/local-storage.service';
import { ContractsService } from './../services/contracts.service';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { DateService } from '../services/date.service';


@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
})
export class PaymentListComponent implements OnInit {

  private inputValue: String = '';
  CONTRACT_TYPE_ELECTRONIC = 1;
  CONTRACT_TYPE_PAPER = 2;

  invoiceStorageURL = `${environment.api_url}`;

  paymentListLoading: Boolean = true;
  contractsList: any = {};
  paymentsList: any = [];
  filteredPaymentsList: any = [];
  periodsList: any = [];
 

  selectedContract = '';
  selectedPeriod = '';



  constructor(
    private contractsService: ContractsService,
    private paymentsService: PaymentsService,
    private localStorageService: LocalStorageService,
    private notificationsService: NotificationsService,
    private dateService: DateService
  ) { paymentsService.clearService(); }

  ngOnInit() {
    this.contractsService.getCompanyContracts(this.localStorageService.get('company')).subscribe(
      (contracts) => {
        this.contractsList = contracts;
        this.paymentListLoading = false;
      },
      (error) => {
        this.notificationsService.error('Ups', 'Błąd przy pobieraniu listy kontraktów');
      }
    );
    this.changeContract(this.selectedContract);
  }

  changePeriod(selectedPeriod) {
    if (selectedPeriod.length) {
      this.filteredPaymentsList = this.paymentsList.filter(value => {
        let period = value.period_start.substring(0, 10) + ' - ' + value.period_end.substring(0, 10);
        if (selectedPeriod === period) {
          return true;
        }
        return false;
      });
      return;
    }
    this.filteredPaymentsList = this.paymentsList;
  }

  changeContract(contractID) {
    this.paymentsService.getPayable(contractID).subscribe(
      (payments) => {
        // console.log(payments);
        this.paymentsList = payments;
        this.filteredPaymentsList = this.paymentsList;
        this.paymentsList.map(value => {
          let period = value.period_start.substring(0, 10) + ' - ' + value.period_end.substring(0, 10);
          if (this.periodsList.indexOf(period) == -1) {
            this.periodsList.push(period);
          }
        });
        this.changePeriod(this.selectedPeriod);
      },
      (error) => {
        // console.log(error);
        this.notificationsService.error('Ups', 'Błąd przy pobieraniu listy płatności');
      }
    );
  }

  payProforma(accessToken) {
    this.paymentsService.payProforma(accessToken).subscribe(
      (payment) => {
        //console.log(payment)
        location.href = String(payment);

        //console.log(payment);
      },
      (error) => {
        // console.log(error);
        this.notificationsService.error('Ups', 'Błąd przy wykonywaniu płatności PayU');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/payments/payment-list.component.ts